/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPresumedTarget = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M12 20.193 20.192 12 12 3.808 3.808 12zM22.314 12 12 1.687 1.686 12 12 22.314z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M12 15.95 15.95 12 12 8.05 8.05 12zM18.071 12 12 5.93 5.929 12 12 18.071z" clipRule="evenodd" /></svg>;
export default SvgPresumedTarget;